import type { ReactNode } from 'react'
import { ScaleContext } from '#contexts/scaleContext.tsx'
import Header from '#ui/Header.tsx'

export function OnboardingWrap(props: {
  children: ReactNode
  hideButtons?: boolean
}) {
  return (
    <ScaleContext value='lg'>
      <Header hideButtons={props.hideButtons} />
      <div className='flex h-[80%] flex-col justify-center'>
        <div className='mx-auto w-full max-w-[33rem] px-8'>
          {props.children}
        </div>
      </div>
    </ScaleContext>
  )
}
